import { useEffect } from "react";

export const VISUAL_VIEWPORT_HEIGHT_CUSTOM_PROPERTY = "--visual-viewport-height";

/**
 * Keeps the document height aligned with the visual viewport on mobile chat.
 * Android Chrome can hide the URL bar without reflowing `height: 100%`, which
 * leaves a blank gap under the composer until the next render.
 */
export function useSyncVisualViewportHeight(isEnabled: boolean): void {
  useEffect(() => {
    if (!isEnabled || typeof window === "undefined") {
      return;
    }

    const rootElement = document.documentElement;

    const syncVisualViewportHeight = () => {
      const viewportHeightPx = window.visualViewport?.height ?? window.innerHeight;
      rootElement.style.setProperty(VISUAL_VIEWPORT_HEIGHT_CUSTOM_PROPERTY, `${viewportHeightPx}px`);
    };

    const visualViewport = window.visualViewport;
    visualViewport?.addEventListener("resize", syncVisualViewportHeight);
    visualViewport?.addEventListener("scroll", syncVisualViewportHeight);
    window.addEventListener("resize", syncVisualViewportHeight);
    window.addEventListener("orientationchange", syncVisualViewportHeight);
    syncVisualViewportHeight();

    return () => {
      visualViewport?.removeEventListener("resize", syncVisualViewportHeight);
      visualViewport?.removeEventListener("scroll", syncVisualViewportHeight);
      window.removeEventListener("resize", syncVisualViewportHeight);
      window.removeEventListener("orientationchange", syncVisualViewportHeight);
      rootElement.style.removeProperty(VISUAL_VIEWPORT_HEIGHT_CUSTOM_PROPERTY);
    };
  }, [isEnabled]);
}
